// Колонка одного слота ряда входов: подпись сверху, плитка снизу. Общая для всех
// трёх каналов (кадры, элементы, референсы) по одной причине — выравнивание.
//
// У кадров над плиткой стоит роль («Первый кадр»), поэтому любая соседняя колонка
// обязана резервировать такую же строку, даже когда подписывать нечего: без неё
// её плитки встают на строку выше и ряд, собранный ради одной линии, разъезжается.
// Держать это правило копиями в каждом канале — значит однажды забыть его в
// четвёртом.

import { cn } from "~/shared/lib/utils";

import type { ReactNode } from "react";

/** Класс пустой плитки-«добавить» — общий вид у всех каналов ряда. */
export const emptySlotTile =
    "flex h-16 w-16 items-center justify-center rounded-md border border-dashed border-white/15 bg-zinc-900/60 text-zinc-500 transition-colors hover:border-white/30 hover:text-zinc-300 disabled:cursor-not-allowed disabled:opacity-40";

export interface SlotColumnProps {
    /** Подпись над плиткой. Не задана — строка всё равно занимает высоту. */
    label?: ReactNode;
    labelTitle?: string;
    labelClassName?: string;
    children: ReactNode;
}

export function SlotColumn({ label, labelTitle, labelClassName, children }: SlotColumnProps) {
    return (
        <div className="flex w-16 flex-col gap-1">
            {/* Место под подпись — фиксированные две строки, прижатые к плитке:
                «Последний кадр» в колонку шириной с плитку одной строкой не влезает,
                а обрезать роль многоточием нельзя — она и отличает слот от соседа. */}
            <span data-slot-label aria-hidden={label === undefined} className="flex h-7 items-end">
                <span
                    title={labelTitle}
                    className={cn("line-clamp-2 text-[11px] leading-[14px] text-zinc-400", labelClassName)}
                >
                    {label ?? " "}
                </span>
            </span>
            {children}
        </div>
    );
}
